import { render, staticRenderFns } from "./email-field.vue?vue&type=template&id=3dacc6a4"
import script from "./email-field.vue?vue&type=script&lang=js"
export * from "./email-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dacc6a4')) {
      api.createRecord('3dacc6a4', component.options)
    } else {
      api.reload('3dacc6a4', component.options)
    }
    module.hot.accept("./email-field.vue?vue&type=template&id=3dacc6a4", function () {
      api.rerender('3dacc6a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formControls/email-field.vue"
export default component.exports